import React from 'react';
// Styles
import styles from './style/drawerGrid.module.css';

function DrawerGrid({ children }:{ children: React.ReactNode }) {
  return (
    <div className={styles.grid}>
      { children }
    </div>
  );
}

export default DrawerGrid;

